import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Flex, Text, useColorModeValue } from '@chakra-ui/react'
import { Link, useLocation } from 'react-router-dom'

interface Props {
    showText: boolean
    id: number
    name: string
    icon: (args1: string) => React.ReactNode
    subItems?: SubItem[]
    url?: string
}

interface SubItem {
    name: string
    url: string
}

const AccordionMenuItem = ({ showText, name, icon, subItems, url }: Props) => {
    const { pathname } = useLocation()
    const backgroundHoverColor = useColorModeValue('green.600', 'green.700')
    const backgroundActiveColor = useColorModeValue('white', 'gray.100')

    const isActive = (value: string): boolean => {
        return pathname.includes(value)
    }

    return (
        <AccordionItem border={0}>
            {
                url ?
                    <Link to={url || ""}>
                        <Box
                            h="60px" w="full" pl={3}
                            backgroundColor={isActive(url) ? backgroundActiveColor : 'transparent'}
                            _hover={{ backgroundColor: isActive(url) ? '#FFF' : backgroundHoverColor }}
                        >
                            <Flex w="full" h="full" justifyContent="flex-start" alignItems="center">
                                {icon(isActive(url) ? '#22543D' : '#FFF')}
                                {
                                    showText &&
                                    <Text
                                        fontWeight="bold"
                                        color={isActive(url) ? '#22543D' : '#FFF'}
                                        fontSize={16}
                                        ml="3"
                                    >
                                        {name}
                                    </Text>
                                }
                            </Flex>
                        </Box>
                    </Link>
                    :
                    <AccordionButton
                        p={0}
                        pr={3}
                        outline="0px"
                        _hover={{ backgroundColor: backgroundHoverColor }}
                        _focus={{ boxShadow: 'none' }}
                    >
                        <Box h="60px" w="full" pl={3}>
                            <Flex w="full" h="full" justifyContent="flex-start" alignItems="center">
                                {icon(isActive(url || "") ? '#FFF' : '#FFF')}
                                {
                                    showText &&
                                    <Text color={'#FFF'} fontSize={16} fontWeight="bold" ml="3">{name}</Text>
                                }
                            </Flex>
                        </Box>
                        <AccordionIcon color={'#FFF'} />
                    </AccordionButton>
            }
            <AccordionPanel p={0}>
                {
                    subItems?.map(item => (
                        <Link key={item.name} to={item.url}>
                            <Box
                                h="60px"
                                w="full"
                                px={6}
                                backgroundColor={isActive(item.url) ? backgroundActiveColor : 'transparent'}
                                _hover={{ backgroundColor: isActive(item.url) ? '#FFF' : backgroundHoverColor }}
                            >
                                <Flex w="full" h="full" justifyContent="flex-start" alignItems="center">
                                    <Text fontSize={16} fontWeight={isActive(item.url) ? "bold" : "normal"} color={isActive(item.url) ? 'green.500' : '#FFF'}>•</Text>
                                    {showText && <Text fontSize={16} fontWeight={isActive(item.url) ? "bold" : "normal"} color={isActive(item.url) ? 'green.500' : '#FFF'} ml="3">{item.name}</Text>}
                                </Flex>
                            </Box>
                        </Link>
                    ))
                }
            </AccordionPanel>
        </AccordionItem>
    )
}

export default AccordionMenuItem